export default "__VITE_ASSET__Brrm2M_g__"